import React from 'react';
import { useLocation } from 'react-router-dom';
import EnhancedNavbar from './EnhancedNavbar';
import PixelBlastBackground from './PixelBlastBackground';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <div className="min-h-screen relative" style={{ background: 'transparent' }}>
      {!isHomePage && <PixelBlastBackground />}
      {/* Enhanced Navigation */}
      <EnhancedNavbar />

      {/* Main Content - Add top padding to account for fixed navbar */}
      <main className="flex-1 pt-16">
        {children}
      </main>

      {/* Footer removed per request - no footer on pages */}
    </div>
  );
};

export default Layout;
